import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useStationsStore } from '../stores/stations.store';

/**
 * Hook for managing station favorites.
 * Uses Zustand store with persistence.
 * Returns favorite IDs, toggle function, and loading state.
 */
export function useStationFavorites() {
  const favoriteIds = useStationsStore(useShallow((state) => state.favoriteStationIds));
  const toggleFavoriteStore = useStationsStore((state) => state.toggleFavorite);

  // Wrapper to maintain async API compatibility
  const toggleFavorite = useCallback(
    async (id: string) => {
      toggleFavoriteStore(id);
    },
    [toggleFavoriteStore],
  );

  // Zustand persist middleware handles loading automatically
  // isLoading is false since Zustand loads synchronously from localStorage
  const isLoading = false;

  return { favoriteIds, toggleFavorite, isLoading };
}
